/**
 * Inicialização de UM slot do AdSense (chamada uma vez por montagem do <ins>, ver AdSlot).
 *
 * DESATIVADA DE PROPÓSITO — não solicita anúncio ao Google, não carrega script e não acessa a rede.
 * Já existem: política de privacidade (/privacidade), /ads.txt e o inventário de cookies (lib/consent.ts).
 * Falta, na etapa de ativação: CSP do Blog + CMP certificada (Privacy & messaging do Google ou equivalente,
 * ver lib/consent.ts, camada B). O pedido do anúncio entra AQUI, só depois de a CMP estar carregada.
 * Retorna se o slot foi inicializado (sempre false nesta etapa).
 */
export function initAdSlot(slot: HTMLElement): boolean {
  void slot
  return false
}
